import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const PoliciesWrapper = (): ReactElement => <Outlet />;

export default PoliciesWrapper;
